import { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { darkLogo } from '../../assets/images/logos';
import { Text } from '../../components';

function detectDevice() {
  const ua = navigator.userAgent || navigator.vendor || window.opera;

  if (/android/i.test(ua)) return 'android';
  if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) return 'ios';

  return 'other';
}

export default function DownloadMUI() {
  const [isOtherDevice, setIsOtherDevice] = useState(false);

  const appStoreLink = 'https://apps.apple.com/br/app/tinco/id1582099314';
  const googlePlayLink = 'https://play.google.com/store/apps/details?id=br.com.rapidorh';

  useEffect(() => {
    const device = detectDevice();

    if (device === 'ios' || device === 'android') {
      window.location.href = device === 'ios' ? appStoreLink : googlePlayLink;
    } else {
      setIsOtherDevice(true);
    }
  }, []);

  return (
    <Grid
      container
      direction="column"
      justifyContent="center"
      sx={{
        minHeight: '60vh',
        width: '100%',
        padding: { xs: 2, sm: 4 },
      }}
    >
      <Grid
        item
        sx={{
          width: '90%',
          maxWidth: 500,
          textAlign: 'center',
          margin: '0 auto',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 3,
        }}
      >
        {isOtherDevice && (
          <>
            <img
              src={darkLogo}
              alt="Logo dark"
              style={{ width: '100%', maxWidth: 200, height: 'auto' }}
            />

            <Text
              variant="h3"
              sx={{
                fontSize: { xs: '1rem', sm: '1.2rem', md: '1.5rem' },
                maxWidth: 500,
                margin: '0 auto',
                textAlign: 'center',
              }}
            >
              Bem-vindo(a) à Tinco! Uma maneira fácil, rápida e organizada de trocar mensagens com
              os gestores da empresa onde você trabalha.
            </Text>
            <Text
              variant="h4"
              sx={{
                fontSize: { xs: '0.9rem', sm: '1rem' },
                marginTop: 2,
                color: 'text.secondary',
                textAlign: 'center',
              }}
            >
              Para ser redirecionado à loja do aplicativo, abra esta página em um dispositivo móvel.
            </Text>
          </>
        )}
      </Grid>
    </Grid>
  );
}
